module.exports = __webpack_public_path__ + "images/kurtosis-faq-03-desktop.png";